'use strict'
/**
 * 店舗ダイレクトジャンプMixin
 * [概要]
 *   店舗への直接アクセスに関連する共通処理の実装です。
 */

import {isEmpty} from 'lodash'

function setDirectStoreCode (directStoreCode) {
  if (!isEmpty(directStoreCode)) {
    sessionStorage.setItem('directStoreCode', directStoreCode)
    return true
  }
  return false
}

export default {
  data () {
    return {
    }
  },
  methods: {
    setDirectStoreCode
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DirectStoreAccessMixin.js